import { defineMessages } from "react-intl"
import { SelectOption } from "../../common/types/select"



export namespace  IMPORT_STATUS {
    export const COMPLETED = "completed"
    export const CREATED = "created"
    export const IN_PROGRESS = "in-progress"

}

export type IMPORT_STATUS = typeof IMPORT_STATUS[keyof typeof IMPORT_STATUS]

export const generateOptions = (intlService) : SelectOption<string>[] => {
    const messages = defineMessages({
        [IMPORT_STATUS.COMPLETED] : {
            id: "import.status_selection.status_completed",
            defaultMessage: "Completed",
        },
        [IMPORT_STATUS.IN_PROGRESS]: {
            id: "import.status_selection.status_in_progress",
            defaultMessage: "In progress",
        },
        [IMPORT_STATUS.CREATED]: {
            id: "import.status_selection.status_created",
            defaultMessage: "Created",
        },
    })
    
    return [
        {
            value: IMPORT_STATUS.CREATED,
            label: intlService.formatMessage(messages[IMPORT_STATUS.CREATED])
        },
        {
            value: IMPORT_STATUS.COMPLETED,
            label: intlService.formatMessage(messages[IMPORT_STATUS.COMPLETED])
        },
        {
            value: IMPORT_STATUS.IN_PROGRESS,
            label: intlService.formatMessage(messages[IMPORT_STATUS.IN_PROGRESS])
        },

    ]
}


// WEBPACK FOOTER //
// ./src/utils/inventory/importStatus.tsx